import { render } from "./EbookView.vue?vue&type=template&id=6f419da0&scoped=true"
import script from "./EbookView.vue?vue&type=script&lang=js"
export * from "./EbookView.vue?vue&type=script&lang=js"

import "./EbookView.vue?vue&type=style&index=0&id=6f419da0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f419da0"]])

export default __exports__